import getApi from '../../api'

export const readTask = (read: boolean) => {
  return getApi().put<null>(`/tasks`, { read })
}
